const I = "AccordionList", R = "Tabs", o = "TabView", _ = "TabPanel", n = "SideNavigation";
export {
  I as ACCORDION_LIST_PROVIDER,
  n as SIDE_NAVIGATION_PROVIDER,
  R as TABS_PROVIDER,
  _ as TAB_PANEL_PROVIDER,
  o as TAB_VIEW_PROVIDER
};
//# sourceMappingURL=providers.js.map
